import {
  getDocumentsSettingsEndpoints,
  IGetDocumentsDTO,
  TGetDocumentsListResponse,
  TGeneralDocumentResponse,
  TCreateDocumentDTO,
  TUpdateDocumentDTO,
  IDeleteDocumentDTO,
} from '@/models/documentsSettings.model';
import { ApiResponse, httpClient } from '@/utils';

class DocumentsSettingsAPI {
  static getDocumentsList({ property_type }: IGetDocumentsDTO): ApiResponse<TGetDocumentsListResponse> {
    const { GET_REQUIRED_DOCUMENTS } = getDocumentsSettingsEndpoints({
      propertyType: property_type,
    });
    return httpClient.get<TGetDocumentsListResponse>(GET_REQUIRED_DOCUMENTS);
  }

  static createDocument({ property_type, ...data }: TCreateDocumentDTO): ApiResponse<TGeneralDocumentResponse> {
    const { CREATE_REQUIRED_DOCUMENTS } = getDocumentsSettingsEndpoints({
      propertyType: property_type,
    });
    return httpClient.post<TGeneralDocumentResponse>(CREATE_REQUIRED_DOCUMENTS, data);
  }

  static updateDocument({ id, property_type, ...data }: TUpdateDocumentDTO): ApiResponse<TGeneralDocumentResponse> {
    const { UPDATE_REQUIRED_DOCUMENTS } = getDocumentsSettingsEndpoints({
      propertyType: property_type,
      id,
    });
    return httpClient.put<TGeneralDocumentResponse>(UPDATE_REQUIRED_DOCUMENTS, data);
  }

  static deleteDocument({ id, property_type }: IDeleteDocumentDTO): ApiResponse<TGeneralDocumentResponse> {
    const { DELETE_REQUIRED_DOCUMENTS } = getDocumentsSettingsEndpoints({
      propertyType: property_type,
      id,
    });
    return httpClient.delete<TGeneralDocumentResponse>(DELETE_REQUIRED_DOCUMENTS);
  }
}

export default DocumentsSettingsAPI;
